import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative flex flex-col h-screen"
}

import { onBeforeMount } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'

// stores
import { useAuthStore } from '@shared/stores/auth'
import useTopAppBarItemsStore from '@shared/stores/top-app-bar'

// composables
import useAppcuesFlow from '@/composables/useAppcuesFlow'

// components
import TheAppBar from '@/components/AppBar/TheAppBar.vue'
import { CLIENT_ID_KEY, INSTANCE_ID_KEY } from '@shared/helpers/AuthorizationParametersHelper'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { isLoading, isAuthenticated } = useAuth0()
const authStore = useAuthStore()
const topAppBarItemsStore = useTopAppBarItemsStore()

useAppcuesFlow()

topAppBarItemsStore.update()

onBeforeMount(async () => {
  const params = new URLSearchParams(window.location.search)
  if (params.has('error', 'access_denied')) {
    localStorage.removeItem(INSTANCE_ID_KEY)
    localStorage.removeItem(CLIENT_ID_KEY)
    await authStore.logoutAndRedirect()
    return
  }
  
  if (isAuthenticated.value) {
     authStore.update()
  }

  topAppBarItemsStore.setToUpdatedVersion(false)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (!_unref(isLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TheAppBar, {
          class: "w-full sticky",
          onOnLogout: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).logoutAndRedirect()))
        }),
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1 /* STABLE */
        }))
      ]))
    : _createCommentVNode("v-if", true)
}
}

})